import { ComponentsManager, Component, EventBus } from '../core/smpl-components.js'
import { MediaSwitch } from '../modules/media-switch.js'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

class PageHeroScroll {
	constructor(el) {
		this.el = el

		this.elTitle = this.el.querySelector('.page-hero__inner')
		this.elBackground = this.el.querySelector('.page-hero__background')

		this.tween = gsap.fromTo(
			this.elBackground,
			{ yPercent: 0 },
			{
				yPercent: 50,
				duration: 1,
				ease: 'linear',
				scrollTrigger: {
					trigger: this.el,
					start: 'top top',
					end: 'bottom top',
					scrub: true,
				},
			},
		)
	}
	destroy() {
		if (this.tween) {
			this.tween.scrollTrigger.kill()
			this.tween.kill()
			this.tween = null
		}
	}
}

//
export default class extends Component {
	prepare() {
		const elMediaSwitch = this.element.querySelector('[data-media-switch]')
		if (elMediaSwitch) {
			this.headerMediaSwitcher = new MediaSwitch(elMediaSwitch, {
				onSwitch: () => {
					console.log('switch')

					ComponentsManager?.loadComponents(elMediaSwitch, () => {})
				},
			})
		}
	}

	mount() {
		this.pageHeroScroll = new PageHeroScroll(this.element)
	}

	unmount() {
		if (this.headerMediaSwitcher) {
			this.headerMediaSwitcher.destroy()
		}

		if (this.pageHeroScroll) {
			this.pageHeroScroll.destroy()
			this.pageHeroScroll = null
		}
	}
}
